module.exports = __webpack_public_path__ + "img/ihsan-mufti.ecc2a66c.jpeg";